import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
import SearchSelect from '@/components/SearchSelect.vue';
import { debounce } from 'lodash-es';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    var onSearch = debounce(function (value) {
      applyService.getSchoolList(value);
    }, 500);
    return function (_ctx, _cache) {
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfTempSchoolName.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "报名学校：可选择或手动填写学校名称",
            name: "tempSchoolName"
          }, {
            default: _withCtx(function () {
              return [_createVNode(SearchSelect, {
                value: _unref(formState).tempSchoolName,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).tempSchoolName = $event;
                }),
                options: _unref(applyService).schoolList,
                onSearch: _unref(onSearch),
                onSelect: _unref(applyService).onSchoolSelect,
                placeholder: "报名学校"
              }, null, 8, ["value", "options", "onSearch", "onSelect"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});